export default __webpack_public_path__ + "static/media/zoom-fit.668562e9.svg";